import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import goal_7_graph_1 from "static/image/onboarding/goal_7_graph_1.svg";
import { BottomNextButton } from "../../../../components/common/BottomNextButton";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

export default function Goal_8_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();
  const handleNext = () => {
    navigate(`/${versionToPathPrefix(version)}-onboarding/goal/9`, {
      replace: true,
    });
  };

  return (
    <Box sx={{ paddingBottom: "180px" }}>
      <Stack
        spacing={10}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"그렇다면 우리는 왜 괴로운 걸까요?"}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "간단합니다. ‘디스턴싱(생각과 거리두기)’ 능력이 약해졌기 때문입니다."
            }
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {"디스턴싱은 마음을 다루는 기술입니다."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "지금부터 약해진 디스턴싱 능력을 스스로 회복해 삶의 중심을 지키는 법을 알려드리겠습니다."
            }
          </CustomTypography>
        </Stack>

        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={goal_7_graph_1}
            alt={"onboarding"}
            style={{
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"다음"}
        highlightBackground={true}
      />
    </Box>
  );
}
